import { Transaction } from '../types/transaction';

export interface MonthlySpending {
  month: string;
  amount: number;
  maxAmount: number;
}

export const getMonthlySpending = (transactions: Transaction[]): MonthlySpending[] => {
  // Create a map to store monthly totals
  const monthlyTotals = new Map<string, number>();

  // Process each transaction
  transactions.forEach(transaction => {
    // Skip positive amounts (income)
    if (transaction.amount >= 0) return;

    // Get the month from the transaction date
    const date = new Date(transaction.date);
    const monthKey = date.toLocaleString('en-US', { month: 'long' });

    // Add the absolute amount to the monthly total
    const currentTotal = monthlyTotals.get(monthKey) || 0;
    monthlyTotals.set(monthKey, currentTotal + Math.abs(transaction.amount));
  });

  // Convert to array and sort by month
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  // Find the maximum amount for progress bar scaling
  const maxAmount = Math.max(...monthlyTotals.values());

  return months
    .filter(month => monthlyTotals.has(month))
    .map(month => ({
      month,
      amount: Math.round(monthlyTotals.get(month) || 0),
      maxAmount
    }));
};
